import React, { Component, useContext } from "react";
import "./../styles/Tables.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { Button } from "./Button";
import { useState, useEffect } from "react";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Moment from "moment";
import { toast } from "react-toastify";
import { ApiCall } from "../../utility/ApiCalls";
import Api_Call from "../../ApiCall";
import UserContext from "../Common/UserContext";
import menus from "../../user-config.json";

const DialogBoxClinical = (props) => {
  console.log("data from half box ", props.cptData);
  const [open, setOpen] = React.useState(false);
  const [rowID, setRowID] = useState("");
  const [cptDescription, setCPTDescription] = useState();
  const [cptCode, setCPTCode] = useState();
  const [cptunits, setCPTUnits] = useState(1);
  const [cptCodeID, setCPTCodeID] = useState();
  const [servicedateto, setserviceTo] = useState(false);
  const [servicedatefrom, setserviceFrom] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { userId, userRole } = useContext(UserContext);

  const handleClickOpen = () => {
    //console.log("index ", index);
    setOpen(true);
    //setRowID(index);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    //if (props.ButtonID == "BtnCPT" && props.proc == "update") {
    setCPTCode(props.cptData[props.rowID].CPTCode_CR);
    setCPTCodeID(props.cptData[props.rowID].UICPTCode_ID);
    setCPTUnits(props.cptData[props.rowID].Unit_NR);
    setserviceFrom(props.cptData[props.rowID].AnticipatedStartDate_DT);
    setserviceTo(props.cptData[props.rowID].AnticipatedEndtDate_DT);
    setCPTDescription(props.cptData[props.rowID].Description);
  }, []);

  async function UpdateCPTDetails() {
    setIsLoading(true);
    const api = new Api_Call();
    const data = await api.putData(`FAX/UPDATE-FIELD`, {
      userId: userId,
      taskId: sessionStorage.getItem("ActiveTaskID"),
      fieldName: "CPT",
      Clinical: menus[userRole.toLowerCase()]["clinical"],
      newValue: {
        CPTCode: cptCode,
        Units: cptunits,
        CPTCode_ID: cptCodeID,
        StartDate: servicedatefrom,
        EndDate: servicedateto,
      },
      op_type: "update",
    });
    toast.success("Update Successful");
    // const retActive = await ApiCall(
    // {
    //     userId: "1",
    //     taskId: sessionStorage.getItem("ActiveTaskID"),
    //     fieldName: "CPT",
    //     Clinical: "1",
    //     newValue: {
    //         CPTCode: cptCode,
    //         Units: cptunits,
    //         CPTCode_ID: cptCodeID,
    //         StartDate: servicedatefrom,
    //         EndDate: servicedateto
    //     },
    //     op_type: "update",
    // },
    // "vcare-ui",
    // "vcare_updatefield"
    // );
    // toast.success("Update Successful");
    const newState = [...props.cptData];
    newState[props.rowID] = {
      CPTCode_CR: cptCode,
      Unit_NR: cptunits,
      Description: cptDescription,
      CPTCode_ID: cptCodeID,
      AnticipatedStartDate_DT: servicedatefrom,
      AnticipatedEndtDate_DT: servicedateto,
    };
    props.setterMethod(newState);
    setOpen(false);
  }

  return (
    <div>
      <BorderColorOutlinedIcon
        sx={{ color: "#2F3744", cursor: "pointer" }}
        onClick={handleClickOpen}
        // onClick={e => handleClickOpen(index)}
      />
      <Dialog open={open} onClose={handleClose} className="add-cpt-dialog">
        <DialogTitle>Update CPT</DialogTitle>
        <DialogContent>
          <DialogContentText> CPT Code: </DialogContentText>
          <TextField
            // autoFocus
            margin="dense"
            id="cpt"
            fullWidth
            variant="standard"
            value={cptCode}
          />
          <DialogContentText> Units: </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="units"
            fullWidth
            variant="standard"
            value={cptunits}
            onChange={(e) => setCPTUnits(e.target.value)}
          />
          <DialogContentText> Service From: </DialogContentText>
          <TextField
            margin="dense"
            id="startdate"
            fullWidth
            variant="standard"
            defaultValue={Moment(servicedatefrom).format("YYYY-MM-DD")}
            onChange={(e) =>
              setserviceFrom(Moment(e.target.value).format("MM/DD/YYYY"))
            }
            type="date"
          />
          <DialogContentText> Service To: </DialogContentText>
          <TextField
            margin="dense"
            id="enddate"
            fullWidth
            variant="standard"
            defaultValue={Moment(servicedateto).format("YYYY-MM-DD")}
            onChange={(e) =>
              setserviceTo(Moment(e.target.value).format("MM/DD/YYYY"))
            }
            type="date"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={UpdateCPTDetails} data-id={rowID}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogBoxClinical;
